import { logger } from "../default-logger";
import { type ILogger, LogLevel, type LogMessage, type LogMetadata, type MetricType } from "../types";

export class TimeLogger {
	private _startTime: number | null = null;
	private _logger: ILogger;

	constructor(loggerInstance?: ILogger) {
		this._logger = loggerInstance ?? logger;
	}

	public Start(): TimeLogger {
		this._startTime = new Date().getTime();
		return this;
	}

	public SetLogger(logger: ILogger) {
		this._logger = logger;
	}

	public ElapsedMs = () => (this._startTime ? new Date().getTime() - this._startTime : 0);

	/**
	 * @param expectedTime - if the elapsed time (ms) exceeds this, the log level is warning instead of info.
	 */
	public StopAndLog(actionName: string, expectedTime: number | null = null): number {
		if (!this._startTime) {
			this._logger.error("METRIC", "Timer error : Timer has not started", actionName);
			return 0;
		}
		const elapsed = this.ElapsedMs();
		this._startTime = null;
		const level = expectedTime && expectedTime < elapsed ? LogLevel.warn : LogLevel.info;
		const metricType: MetricType = {
			name: actionName,
			elapsed_time_ms: Number(elapsed),
			elapsed_time_s: Number((elapsed / 1000).toFixed(2)),
		};
		this._logger.log(level, "METRIC", { metrics: metricType });
		return elapsed;
	}

	public StopAndLogMessage(
		level: LogLevel,
		actionName: string,
		message: LogMessage,
		...optionalParams: LogMetadata[]
	): number {
		if (!this._startTime) {
			this._logger.error("METRIC", "Timer error : Timer has not started", message);
			return 0;
		}
		const elapsed = this.ElapsedMs();
		this._startTime = null;
		const metricType: MetricType = {
			name: actionName,
			elapsed_time_ms: Number(elapsed),
			elapsed_time_s: Number((elapsed / 1000).toFixed(2)),
		};
		this._logger.log(level, "METRIC", { message, metrics: metricType }, ...optionalParams);
		return elapsed;
	}
}
